// Import PDF templates as URLs (webpack will bundle them securely)
import gashaardTemplate from '../assets/templates/gashaard.pdf';
import houteKachelTemplate from '../assets/templates/Houte Kachel.pdf';
import kolenkachelTemplate from '../assets/templates/kolenkachel.pdf';
import pelletkachelTemplate from '../assets/templates/pelletkachel.pdf';

// Secure template mapping
const templates = {
  'gashaard': gashaardTemplate,
  'Houte Kachel': houteKachelTemplate,
  'kolenkachel': kolenkachelTemplate,
  'pelletkachel': pelletkachelTemplate
};

/**
 * Loads a PDF template securely from the bundled assets
 * @param {string} templateType - Type of template to load
 * @returns {Promise<ArrayBuffer>} - PDF template as ArrayBuffer
 */
export const loadTemplate = async (templateType) => {
  const templateUrl = templates[templateType];
  
  if (!templateUrl) {
    throw new Error(`Template not found: ${templateType}`);
  }
  
  try {
    const response = await fetch(templateUrl);
    
    if (!response.ok) {
      throw new Error(`Failed to load template: ${response.statusText}`);
    }
    
    return await response.arrayBuffer();
  } catch (error) {
    console.error('Error loading template:', error);
    throw error;
  }
};

/**
 * Get list of available templates
 * @returns {Array<string>} - Array of template names
 */
export const getAvailableTemplates = () => {
  return Object.keys(templates);
};

/**
 * Check if template exists
 * @param {string} templateType - Type of template to check
 * @returns {boolean} - Whether template exists
 */
export const templateExists = (templateType) => {
  return templateType in templates;
};